import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import KitchenNewEditForm from '../kitchen-new-edit-form';

export default function KitchenCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new inventory item"
        links={[
          {
            name: 'Inventory Items',
            href: paths.dashboard.kitchen.root(),
          },
          { name: 'Create a new inventory item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <KitchenNewEditForm />
    </Container>
  );
}
